import { EditSubcatagoryComponent } from './../../modules/subcatagory/edit-subcatagory/edit-subcatagory.component';
import { AddSubcatagoryComponent } from './../../modules/subcatagory/add-subcatagory/add-subcatagory.component';
import { SubcatagoriesComponent } from './../../modules/subcatagory/subcatagories/subcatagories.component';
import { ChangeProfilePasswordComponent } from './../../modules/change-profile-password/change-profile-password.component';
import { UserProfileComponent } from './../../modules/user-profile/user-profile.component';
import { MustMatchDirective } from './../_Form/must-match.directive';
import { AddBannerComponent } from './../../modules/Banner/add-banner/add-banner.component';
import { BannersComponent } from './../../modules/Banner/banners/banners.component';
import { EditBannerComponent } from './../../modules/Banner/edit-banner/edit-banner.component';
import { ManageContentComponent } from './../../modules/manage-content/manage-content.component';
import { ContactUsComponent } from './../../modules/contact-us/contact-us.component';
import { EditVoucherComponent } from './../../modules/voucher/edit-voucher/edit-voucher.component';
import { AddVoucherComponent } from './../../modules/voucher/add-voucher/add-voucher.component';
import { VouchersComponent } from './../../modules/voucher/vouchers/vouchers.component';
import { EditCatagoryComponent } from './../../modules/catagory/edit-catagory/edit-catagory.component';
import { AddCatagoryComponent } from './../../modules/catagory/add-catagory/add-catagory.component';
import { CatagoryListComponent } from './../../modules/catagory/catagory-list/catagory-list.component';
import { EditDishComponent } from './../../modules/edit-dish/edit-dish.component';
import { AddDishComponent } from './../../modules/add-dish/add-dish.component';
import { RestaurantMenuComponent } from './../../modules/restaurant-menu/restaurant-menu.component';
import { DishManagerComponent } from './../../modules/dish-manager/dish-manager.component';
import { RestaurantManagerComponent } from './../../modules/restaurant-manager/restaurant-manager.component';
import { AddRestaurantComponent } from './../../modules/add-restaurant/add-restaurant.component';
import { EditRestaurantComponent } from './../../modules/edit-restaurant/edit-restaurant.component';
import { EditDeliveryPartnerComponent } from './../../modules/edit-delivery-partner/edit-delivery-partner.component';
import { AddDeliveryPartnerComponent } from './../../modules/add-delivery-partner/add-delivery-partner.component';
import { DeliveryPartnerComponent } from './../../modules/delivery-partner/delivery-partner.component';
import { EditOfferComponent } from './../../modules/edit-offer/edit-offer.component';
import { AddOfferComponent } from './../../modules/add-offer/add-offer.component';
import { OfferManagerComponent } from './../../modules/offer-manager/offer-manager.component';
import { EditUserComponent } from './../../modules/edit-user/edit-user.component';
import { ViewProfileComponent } from './../../modules/view-profile/view-profile.component';
import { OrderDetailComponent } from './../../modules/order-detail/order-detail.component';
import { OrderManagerComponent } from './../../modules/order-manager/order-manager.component';
import { AddMemberComponent } from './../../modules/add-member/add-member.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { environment } from './../../../environments/environment';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { AngularFireDatabase, AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireStorage, AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireModule } from '@angular/fire';
import { ChangePasswordComponent } from './../../LoginPages/change-password/change-password.component';
import { OtpComponent } from './../../LoginPages/otp/otp.component';
import { ForgetPasswordComponent } from './../../LoginPages/forget-password/forget-password.component';
import { LoginComponent } from './../../LoginPages/login/login.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDividerModule } from '@angular/material/divider';
import { SharedModule } from './../../shared/shared.module';
import { DashboardComponent } from './../../modules/dashboard/dashboard.component';
import { RouterModule } from '@angular/router';
import { DefaultComponent } from './default.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import {MatCardModule} from '@angular/material/card';
import { DashboardService } from 'src/app/modules/dashboard.service';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MemberlistComponent } from 'src/app/modules/memberlist/memberlist.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule, FormsModule, FormGroup } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import {MatInputModule} from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { ResetPasswordComponent } from 'src/app/LoginPages/reset-password/reset-password.component';
import firebaseConfig from 'src/app/firebaseapi';
import { MatSelectModule } from '@angular/material/select';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import { RatingModule } from 'ng-starrating';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
@NgModule({
  declarations: [
    DefaultComponent,
    DashboardComponent,
    MemberlistComponent,
    LoginComponent,
    ForgetPasswordComponent,
    OtpComponent,
    ResetPasswordComponent,
    ChangePasswordComponent,
    AddMemberComponent,
    OrderManagerComponent,
    OrderDetailComponent,
    ViewProfileComponent,
    EditUserComponent,
    OfferManagerComponent,
    AddOfferComponent,
    EditOfferComponent,
    DeliveryPartnerComponent,
    AddDeliveryPartnerComponent,
    EditDeliveryPartnerComponent,
    RestaurantManagerComponent,
    AddRestaurantComponent,
    EditRestaurantComponent,
    DishManagerComponent,
    RestaurantMenuComponent,
    AddDishComponent,
    EditDishComponent,
    CatagoryListComponent,
    AddCatagoryComponent,
    EditCatagoryComponent,
    VouchersComponent,
    AddVoucherComponent,
    EditVoucherComponent,
    ContactUsComponent,
    ManageContentComponent,
    BannersComponent,
    AddBannerComponent,
    UserProfileComponent,
    EditBannerComponent,
    MustMatchDirective,
    ChangeProfilePasswordComponent,
    SubcatagoriesComponent,
    AddSubcatagoryComponent,
    EditSubcatagoryComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    RouterModule,
    SharedModule,
   MatSidenavModule,
   MatDividerModule,
   FlexLayoutModule,
   MatGridListModule,
   MatCardModule,
   MatPaginatorModule,
   ReactiveFormsModule,
   MatFormFieldModule,
   MatTableModule,
   MatInputModule ,
   MatSortModule,
   BrowserModule,
   HttpClientModule,
   FormsModule,
   MatIconModule,
   MatButtonModule,
   AngularFireModule.initializeApp(environment.firebase),
   AngularFireStorageModule,
   AngularFireDatabaseModule,
   MatSlideToggleModule,
   MatInputModule,MatSelectModule,
   MatDatepickerModule,
   MatNativeDateModule,
   MatRippleModule,RatingModule
  ],
  providers:
  [
    DashboardService
  ]
})
export class DefaultModule { }
